// extracted by mini-css-extract-plugin
export default {"pageBlank":"kUAXH63D9afHz6VGZQRC","cactus":"k07x7U_mONdmvrHeNrwZ"};